import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { Table, TableBody, TableCell, TableRow, Paper } from "@mui/material";

const propTypes = {
	keyValuePairs: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			value: PropTypes.string
		})
	),
	classes: PropTypes.object
};

const defaultProps = {
	keyValuePairs: [
		{
			key: "",
			value: ""
		}
	]
};

const styles = {
	selected: {
		backgroundColor: "rgba(149, 150, 151, 0.4) !important"
	}
};

const CBKvpDisplay = ({ keyValuePairs, classes }) => {
	return (
		<Paper>
			<Table data-testid="orion-components-cbcomponents-cbkvp-display-cbkvp-display-table">
				<TableBody data-testid="orion-components-cbcomponents-cbkvp-display-cbkvp-display-table-body">
					{keyValuePairs.map((pair, index) => {
						return (
							<TableRow
								key={pair.key + index}
								classes={{ selected: classes.selected }}
								selected={index % 2 === 0 ? true : false} data-testid="orion-components-cbcomponents-cbkvp-display-cbkvp-display-table-row"
							>
								<TableCell style={{ padding: "4px 24px 4px 24px" }} data-testid="orion-components-cbcomponents-cbkvp-display-cbkvp-display-table-cell">{pair.key}</TableCell>
								<TableCell style={{ padding: "4px 24px 4px 24px" }} data-testid="orion-components-cbcomponents-cbkvp-display-cbkvp-display-table-cell-2">{pair.value}</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</Paper>
	);
};

CBKvpDisplay.propTypes = propTypes;
CBKvpDisplay.defaultProps = defaultProps;

export default withStyles(styles)(CBKvpDisplay);
